/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateShow = /* GraphQL */ `subscription OnCreateShow {
  onCreateShow {
    id
    name
    version
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateShowSubscriptionVariables,
  APITypes.OnCreateShowSubscription
>;
export const onUpdateShow = /* GraphQL */ `subscription OnUpdateShow {
  onUpdateShow {
    id
    name
    version
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateShowSubscriptionVariables,
  APITypes.OnUpdateShowSubscription
>;
export const onDeleteShow = /* GraphQL */ `subscription OnDeleteShow {
  onDeleteShow {
    id
    name
    version
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteShowSubscriptionVariables,
  APITypes.OnDeleteShowSubscription
>;
export const onCreateShowSetting = /* GraphQL */ `subscription OnCreateShowSetting {
  onCreateShowSetting {
    id
    name
    title
    description
    slug
    startDateTime
    endDateTime
    status
    owner
    showID
    version
    createdAt
    updatedAt
    ogpImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateShowSettingSubscriptionVariables,
  APITypes.OnCreateShowSettingSubscription
>;
export const onUpdateShowSetting = /* GraphQL */ `subscription OnUpdateShowSetting {
  onUpdateShowSetting {
    id
    name
    title
    description
    slug
    startDateTime
    endDateTime
    status
    owner
    showID
    version
    createdAt
    updatedAt
    ogpImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateShowSettingSubscriptionVariables,
  APITypes.OnUpdateShowSettingSubscription
>;
export const onDeleteShowSetting = /* GraphQL */ `subscription OnDeleteShowSetting {
  onDeleteShowSetting {
    id
    name
    title
    description
    slug
    startDateTime
    endDateTime
    status
    owner
    showID
    version
    createdAt
    updatedAt
    ogpImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteShowSettingSubscriptionVariables,
  APITypes.OnDeleteShowSettingSubscription
>;
export const onCreateShowMain = /* GraphQL */ `subscription OnCreateShowMain {
  onCreateShowMain {
    id
    title
    mapDiscription
    logoDiscription
    discription
    section
    status
    showID
    search
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateShowMainSubscriptionVariables,
  APITypes.OnCreateShowMainSubscription
>;
export const onUpdateShowMain = /* GraphQL */ `subscription OnUpdateShowMain {
  onUpdateShowMain {
    id
    title
    mapDiscription
    logoDiscription
    discription
    section
    status
    showID
    search
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateShowMainSubscriptionVariables,
  APITypes.OnUpdateShowMainSubscription
>;
export const onDeleteShowMain = /* GraphQL */ `subscription OnDeleteShowMain {
  onDeleteShowMain {
    id
    title
    mapDiscription
    logoDiscription
    discription
    section
    status
    showID
    search
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteShowMainSubscriptionVariables,
  APITypes.OnDeleteShowMainSubscription
>;
export const onCreateTeaser = /* GraphQL */ `subscription OnCreateTeaser {
  onCreateTeaser {
    id
    title
    discription
    countDown
    section
    status
    showID
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTeaserSubscriptionVariables,
  APITypes.OnCreateTeaserSubscription
>;
export const onUpdateTeaser = /* GraphQL */ `subscription OnUpdateTeaser {
  onUpdateTeaser {
    id
    title
    discription
    countDown
    section
    status
    showID
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTeaserSubscriptionVariables,
  APITypes.OnUpdateTeaserSubscription
>;
export const onDeleteTeaser = /* GraphQL */ `subscription OnDeleteTeaser {
  onDeleteTeaser {
    id
    title
    discription
    countDown
    section
    status
    showID
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTeaserSubscriptionVariables,
  APITypes.OnDeleteTeaserSubscription
>;
export const onCreatePage = /* GraphQL */ `subscription OnCreatePage {
  onCreatePage {
    id
    root
    slug
    title
    discription
    contents
    status
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePageSubscriptionVariables,
  APITypes.OnCreatePageSubscription
>;
export const onUpdatePage = /* GraphQL */ `subscription OnUpdatePage {
  onUpdatePage {
    id
    root
    slug
    title
    discription
    contents
    status
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePageSubscriptionVariables,
  APITypes.OnUpdatePageSubscription
>;
export const onDeletePage = /* GraphQL */ `subscription OnDeletePage {
  onDeletePage {
    id
    root
    slug
    title
    discription
    contents
    status
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePageSubscriptionVariables,
  APITypes.OnDeletePageSubscription
>;
export const onCreateTopPage = /* GraphQL */ `subscription OnCreateTopPage {
  onCreateTopPage {
    id
    title
    discription
    contents
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTopPageSubscriptionVariables,
  APITypes.OnCreateTopPageSubscription
>;
export const onUpdateTopPage = /* GraphQL */ `subscription OnUpdateTopPage {
  onUpdateTopPage {
    id
    title
    discription
    contents
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTopPageSubscriptionVariables,
  APITypes.OnUpdateTopPageSubscription
>;
export const onDeleteTopPage = /* GraphQL */ `subscription OnDeleteTopPage {
  onDeleteTopPage {
    id
    title
    discription
    contents
    owner
    version
    createdAt
    updatedAt
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTopPageSubscriptionVariables,
  APITypes.OnDeleteTopPageSubscription
>;
export const onCreateShowBooth = /* GraphQL */ `subscription OnCreateShowBooth {
  onCreateShowBooth {
    id
    name
    title
    discription
    section
    priority
    status
    showID
    owner
    version
    createdAt
    updatedAt
    brandLogos {
      id
      name
      owner
      version
      createdAt
      updatedAt
      phots {
        items {
          id
          albumID
          photID
          albumOrder
          owner
          version
          createdAt
          updatedAt
          album {
            id
            name
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          phot {
            id
            alternate
            url
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateShowBoothSubscriptionVariables,
  APITypes.OnCreateShowBoothSubscription
>;
export const onUpdateShowBooth = /* GraphQL */ `subscription OnUpdateShowBooth {
  onUpdateShowBooth {
    id
    name
    title
    discription
    section
    priority
    status
    showID
    owner
    version
    createdAt
    updatedAt
    brandLogos {
      id
      name
      owner
      version
      createdAt
      updatedAt
      phots {
        items {
          id
          albumID
          photID
          albumOrder
          owner
          version
          createdAt
          updatedAt
          album {
            id
            name
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          phot {
            id
            alternate
            url
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateShowBoothSubscriptionVariables,
  APITypes.OnUpdateShowBoothSubscription
>;
export const onDeleteShowBooth = /* GraphQL */ `subscription OnDeleteShowBooth {
  onDeleteShowBooth {
    id
    name
    title
    discription
    section
    priority
    status
    showID
    owner
    version
    createdAt
    updatedAt
    brandLogos {
      id
      name
      owner
      version
      createdAt
      updatedAt
      phots {
        items {
          id
          albumID
          photID
          albumOrder
          owner
          version
          createdAt
          updatedAt
          album {
            id
            name
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          phot {
            id
            alternate
            url
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    backgroundImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteShowBoothSubscriptionVariables,
  APITypes.OnDeleteShowBoothSubscription
>;
export const onCreateShowBoothItem = /* GraphQL */ `subscription OnCreateShowBoothItem {
  onCreateShowBoothItem {
    id
    name
    title
    readingName
    description
    keyword
    movie
    brand
    price
    boatType
    height
    capacity
    view360
    section
    productUrl
    mapPriority
    badge
    status
    boothID
    showID
    owner
    version
    priority
    mapIndex
    boothIndex
    boothOrder
    mapOrder
    isExhibition
    createdAt
    updatedAt
    photoGallery {
      id
      name
      owner
      version
      createdAt
      updatedAt
      phots {
        items {
          id
          albumID
          photID
          albumOrder
          owner
          version
          createdAt
          updatedAt
          album {
            id
            name
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          phot {
            id
            alternate
            url
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    mainImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    logo {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    mapIcon {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    thumbnail {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateShowBoothItemSubscriptionVariables,
  APITypes.OnCreateShowBoothItemSubscription
>;
export const onUpdateShowBoothItem = /* GraphQL */ `subscription OnUpdateShowBoothItem {
  onUpdateShowBoothItem {
    id
    name
    title
    readingName
    description
    keyword
    movie
    brand
    price
    boatType
    height
    capacity
    view360
    section
    productUrl
    mapPriority
    badge
    status
    boothID
    showID
    owner
    version
    priority
    mapIndex
    boothIndex
    boothOrder
    mapOrder
    isExhibition
    createdAt
    updatedAt
    photoGallery {
      id
      name
      owner
      version
      createdAt
      updatedAt
      phots {
        items {
          id
          albumID
          photID
          albumOrder
          owner
          version
          createdAt
          updatedAt
          album {
            id
            name
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          phot {
            id
            alternate
            url
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    mainImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    logo {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    mapIcon {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    thumbnail {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateShowBoothItemSubscriptionVariables,
  APITypes.OnUpdateShowBoothItemSubscription
>;
export const onDeleteShowBoothItem = /* GraphQL */ `subscription OnDeleteShowBoothItem {
  onDeleteShowBoothItem {
    id
    name
    title
    readingName
    description
    keyword
    movie
    brand
    price
    boatType
    height
    capacity
    view360
    section
    productUrl
    mapPriority
    badge
    status
    boothID
    showID
    owner
    version
    priority
    mapIndex
    boothIndex
    boothOrder
    mapOrder
    isExhibition
    createdAt
    updatedAt
    photoGallery {
      id
      name
      owner
      version
      createdAt
      updatedAt
      phots {
        items {
          id
          albumID
          photID
          albumOrder
          owner
          version
          createdAt
          updatedAt
          album {
            id
            name
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          phot {
            id
            alternate
            url
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    mainImage {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    logo {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    mapIcon {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    thumbnail {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteShowBoothItemSubscriptionVariables,
  APITypes.OnDeleteShowBoothItemSubscription
>;
export const onCreateBoothUserInfo = /* GraphQL */ `subscription OnCreateBoothUserInfo {
  onCreateBoothUserInfo {
    id
    chatUrl
    chatStatus
    contactTel
    contactTelInfo
    contactEmail
    contactAddress
    web
    facebook
    boothID
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateBoothUserInfoSubscriptionVariables,
  APITypes.OnCreateBoothUserInfoSubscription
>;
export const onUpdateBoothUserInfo = /* GraphQL */ `subscription OnUpdateBoothUserInfo {
  onUpdateBoothUserInfo {
    id
    chatUrl
    chatStatus
    contactTel
    contactTelInfo
    contactEmail
    contactAddress
    web
    facebook
    boothID
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateBoothUserInfoSubscriptionVariables,
  APITypes.OnUpdateBoothUserInfoSubscription
>;
export const onDeleteBoothUserInfo = /* GraphQL */ `subscription OnDeleteBoothUserInfo {
  onDeleteBoothUserInfo {
    id
    chatUrl
    chatStatus
    contactTel
    contactTelInfo
    contactEmail
    contactAddress
    web
    facebook
    boothID
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteBoothUserInfoSubscriptionVariables,
  APITypes.OnDeleteBoothUserInfoSubscription
>;
export const onCreateAlbum = /* GraphQL */ `subscription OnCreateAlbum {
  onCreateAlbum {
    id
    name
    owner
    version
    createdAt
    updatedAt
    phots {
      items {
        id
        albumID
        photID
        albumOrder
        owner
        version
        createdAt
        updatedAt
        album {
          id
          name
          owner
          version
          createdAt
          updatedAt
          phots {
            nextToken
            __typename
          }
          __typename
        }
        phot {
          id
          alternate
          storage {
            bucket
            region
            key
            __typename
          }
          url
          owner
          version
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAlbumSubscriptionVariables,
  APITypes.OnCreateAlbumSubscription
>;
export const onUpdateAlbum = /* GraphQL */ `subscription OnUpdateAlbum {
  onUpdateAlbum {
    id
    name
    owner
    version
    createdAt
    updatedAt
    phots {
      items {
        id
        albumID
        photID
        albumOrder
        owner
        version
        createdAt
        updatedAt
        album {
          id
          name
          owner
          version
          createdAt
          updatedAt
          phots {
            nextToken
            __typename
          }
          __typename
        }
        phot {
          id
          alternate
          storage {
            bucket
            region
            key
            __typename
          }
          url
          owner
          version
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAlbumSubscriptionVariables,
  APITypes.OnUpdateAlbumSubscription
>;
export const onDeleteAlbum = /* GraphQL */ `subscription OnDeleteAlbum {
  onDeleteAlbum {
    id
    name
    owner
    version
    createdAt
    updatedAt
    phots {
      items {
        id
        albumID
        photID
        albumOrder
        owner
        version
        createdAt
        updatedAt
        album {
          id
          name
          owner
          version
          createdAt
          updatedAt
          phots {
            nextToken
            __typename
          }
          __typename
        }
        phot {
          id
          alternate
          storage {
            bucket
            region
            key
            __typename
          }
          url
          owner
          version
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAlbumSubscriptionVariables,
  APITypes.OnDeleteAlbumSubscription
>;
export const onCreateBoothBoatType = /* GraphQL */ `subscription OnCreateBoothBoatType {
  onCreateBoothBoatType {
    id
    name
    priority
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateBoothBoatTypeSubscriptionVariables,
  APITypes.OnCreateBoothBoatTypeSubscription
>;
export const onUpdateBoothBoatType = /* GraphQL */ `subscription OnUpdateBoothBoatType {
  onUpdateBoothBoatType {
    id
    name
    priority
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateBoothBoatTypeSubscriptionVariables,
  APITypes.OnUpdateBoothBoatTypeSubscription
>;
export const onDeleteBoothBoatType = /* GraphQL */ `subscription OnDeleteBoothBoatType {
  onDeleteBoothBoatType {
    id
    name
    priority
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteBoothBoatTypeSubscriptionVariables,
  APITypes.OnDeleteBoothBoatTypeSubscription
>;
export const onCreateBoothBoatBrand = /* GraphQL */ `subscription OnCreateBoothBoatBrand {
  onCreateBoothBoatBrand {
    id
    name
    priority
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateBoothBoatBrandSubscriptionVariables,
  APITypes.OnCreateBoothBoatBrandSubscription
>;
export const onUpdateBoothBoatBrand = /* GraphQL */ `subscription OnUpdateBoothBoatBrand {
  onUpdateBoothBoatBrand {
    id
    name
    priority
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateBoothBoatBrandSubscriptionVariables,
  APITypes.OnUpdateBoothBoatBrandSubscription
>;
export const onDeleteBoothBoatBrand = /* GraphQL */ `subscription OnDeleteBoothBoatBrand {
  onDeleteBoothBoatBrand {
    id
    name
    priority
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteBoothBoatBrandSubscriptionVariables,
  APITypes.OnDeleteBoothBoatBrandSubscription
>;
export const onCreateAlbumPhot = /* GraphQL */ `subscription OnCreateAlbumPhot {
  onCreateAlbumPhot {
    id
    albumID
    photID
    albumOrder
    owner
    version
    createdAt
    updatedAt
    album {
      id
      name
      owner
      version
      createdAt
      updatedAt
      phots {
        items {
          id
          albumID
          photID
          albumOrder
          owner
          version
          createdAt
          updatedAt
          album {
            id
            name
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          phot {
            id
            alternate
            url
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    phot {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAlbumPhotSubscriptionVariables,
  APITypes.OnCreateAlbumPhotSubscription
>;
export const onUpdateAlbumPhot = /* GraphQL */ `subscription OnUpdateAlbumPhot {
  onUpdateAlbumPhot {
    id
    albumID
    photID
    albumOrder
    owner
    version
    createdAt
    updatedAt
    album {
      id
      name
      owner
      version
      createdAt
      updatedAt
      phots {
        items {
          id
          albumID
          photID
          albumOrder
          owner
          version
          createdAt
          updatedAt
          album {
            id
            name
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          phot {
            id
            alternate
            url
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    phot {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAlbumPhotSubscriptionVariables,
  APITypes.OnUpdateAlbumPhotSubscription
>;
export const onDeleteAlbumPhot = /* GraphQL */ `subscription OnDeleteAlbumPhot {
  onDeleteAlbumPhot {
    id
    albumID
    photID
    albumOrder
    owner
    version
    createdAt
    updatedAt
    album {
      id
      name
      owner
      version
      createdAt
      updatedAt
      phots {
        items {
          id
          albumID
          photID
          albumOrder
          owner
          version
          createdAt
          updatedAt
          album {
            id
            name
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          phot {
            id
            alternate
            url
            owner
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    phot {
      id
      alternate
      storage {
        bucket
        region
        key
        __typename
      }
      url
      owner
      version
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAlbumPhotSubscriptionVariables,
  APITypes.OnDeleteAlbumPhotSubscription
>;
export const onCreateImage = /* GraphQL */ `subscription OnCreateImage {
  onCreateImage {
    id
    alternate
    storage {
      bucket
      region
      key
      __typename
    }
    url
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateImageSubscriptionVariables,
  APITypes.OnCreateImageSubscription
>;
export const onUpdateImage = /* GraphQL */ `subscription OnUpdateImage {
  onUpdateImage {
    id
    alternate
    storage {
      bucket
      region
      key
      __typename
    }
    url
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateImageSubscriptionVariables,
  APITypes.OnUpdateImageSubscription
>;
export const onDeleteImage = /* GraphQL */ `subscription OnDeleteImage {
  onDeleteImage {
    id
    alternate
    storage {
      bucket
      region
      key
      __typename
    }
    url
    owner
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteImageSubscriptionVariables,
  APITypes.OnDeleteImageSubscription
>;
export const onCreateShowAudience = /* GraphQL */ `subscription OnCreateShowAudience {
  onCreateShowAudience {
    id
    showID
    userID
    owner
    version
    createdAt
    updatedAt
    show {
      id
      name
      version
      owner
      createdAt
      updatedAt
      __typename
    }
    users {
      id
      identity_id
      email
      group
      version
      createdAt
      updatedAt
      tickets {
        items {
          id
          status
          group
          version
          createdAt
          updatedAt
          activatedUser {
            id
            identity_id
            email
            group
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateShowAudienceSubscriptionVariables,
  APITypes.OnCreateShowAudienceSubscription
>;
export const onUpdateShowAudience = /* GraphQL */ `subscription OnUpdateShowAudience {
  onUpdateShowAudience {
    id
    showID
    userID
    owner
    version
    createdAt
    updatedAt
    show {
      id
      name
      version
      owner
      createdAt
      updatedAt
      __typename
    }
    users {
      id
      identity_id
      email
      group
      version
      createdAt
      updatedAt
      tickets {
        items {
          id
          status
          group
          version
          createdAt
          updatedAt
          activatedUser {
            id
            identity_id
            email
            group
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateShowAudienceSubscriptionVariables,
  APITypes.OnUpdateShowAudienceSubscription
>;
export const onDeleteShowAudience = /* GraphQL */ `subscription OnDeleteShowAudience {
  onDeleteShowAudience {
    id
    showID
    userID
    owner
    version
    createdAt
    updatedAt
    show {
      id
      name
      version
      owner
      createdAt
      updatedAt
      __typename
    }
    users {
      id
      identity_id
      email
      group
      version
      createdAt
      updatedAt
      tickets {
        items {
          id
          status
          group
          version
          createdAt
          updatedAt
          activatedUser {
            id
            identity_id
            email
            group
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteShowAudienceSubscriptionVariables,
  APITypes.OnDeleteShowAudienceSubscription
>;
export const onCreateUser = /* GraphQL */ `subscription OnCreateUser {
  onCreateUser {
    id
    identity_id
    email
    group
    version
    createdAt
    updatedAt
    tickets {
      items {
        id
        status
        group
        version
        createdAt
        updatedAt
        activatedUser {
          id
          identity_id
          email
          group
          version
          createdAt
          updatedAt
          tickets {
            nextToken
            __typename
          }
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserSubscriptionVariables,
  APITypes.OnCreateUserSubscription
>;
export const onUpdateUser = /* GraphQL */ `subscription OnUpdateUser {
  onUpdateUser {
    id
    identity_id
    email
    group
    version
    createdAt
    updatedAt
    tickets {
      items {
        id
        status
        group
        version
        createdAt
        updatedAt
        activatedUser {
          id
          identity_id
          email
          group
          version
          createdAt
          updatedAt
          tickets {
            nextToken
            __typename
          }
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserSubscriptionVariables,
  APITypes.OnUpdateUserSubscription
>;
export const onDeleteUser = /* GraphQL */ `subscription OnDeleteUser {
  onDeleteUser {
    id
    identity_id
    email
    group
    version
    createdAt
    updatedAt
    tickets {
      items {
        id
        status
        group
        version
        createdAt
        updatedAt
        activatedUser {
          id
          identity_id
          email
          group
          version
          createdAt
          updatedAt
          tickets {
            nextToken
            __typename
          }
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserSubscriptionVariables,
  APITypes.OnDeleteUserSubscription
>;
export const onCreateTicket = /* GraphQL */ `subscription OnCreateTicket {
  onCreateTicket {
    id
    status
    group
    version
    createdAt
    updatedAt
    activatedUser {
      id
      identity_id
      email
      group
      version
      createdAt
      updatedAt
      tickets {
        items {
          id
          status
          group
          version
          createdAt
          updatedAt
          activatedUser {
            id
            identity_id
            email
            group
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTicketSubscriptionVariables,
  APITypes.OnCreateTicketSubscription
>;
export const onUpdateTicket = /* GraphQL */ `subscription OnUpdateTicket {
  onUpdateTicket {
    id
    status
    group
    version
    createdAt
    updatedAt
    activatedUser {
      id
      identity_id
      email
      group
      version
      createdAt
      updatedAt
      tickets {
        items {
          id
          status
          group
          version
          createdAt
          updatedAt
          activatedUser {
            id
            identity_id
            email
            group
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTicketSubscriptionVariables,
  APITypes.OnUpdateTicketSubscription
>;
export const onDeleteTicket = /* GraphQL */ `subscription OnDeleteTicket {
  onDeleteTicket {
    id
    status
    group
    version
    createdAt
    updatedAt
    activatedUser {
      id
      identity_id
      email
      group
      version
      createdAt
      updatedAt
      tickets {
        items {
          id
          status
          group
          version
          createdAt
          updatedAt
          activatedUser {
            id
            identity_id
            email
            group
            version
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTicketSubscriptionVariables,
  APITypes.OnDeleteTicketSubscription
>;
